"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkstreamCard = exports.WorkstreamCardDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var card_1 = require("../elements/card");
var content_1 = require("../elements/content");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
var use_entities_1 = require("../../hooks/use-entities");
var use_app_options_1 = require("../../hooks/use-app-options");
var format_date_string_1 = require("../../utils/format-date-string");
var definition_table_1 = require("../elements/definition-table");
var link_1 = require("../elements/link");
var icon_button_1 = require("../elements/icon-button");
var lodash_1 = require("lodash");
var item_number_1 = require("../elements/item-number");
var task_item_1 = require("./task-item");
var project_status_label_1 = require("./project-status-label");
var entity_link_1 = require("./entity-link");
var cell_label_1 = require("../elements/cell-label");
var entity_cell_header_1 = require("./entity-cell-header");
exports.WorkstreamCardDefaultProps = {
  statusLabel: 'Status',
  backgroundColor: 'light'
};
// -------- Styles -------->
var CardStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    display: flex;\n    height: auto;\n    font-size: ", ";\n    margin-top: 8px;\n    border-bottom: 1px solid ", ";\n    margin-bottom: ", ";\n  "], ["\n    ", ";\n    display: flex;\n    height: auto;\n    font-size: ", ";\n    margin-top: 8px;\n    border-bottom: 1px solid ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(15), theme_1.theme.COLOR('line-semi-subtle'), theme_1.theme.UNIT(2))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-grow: 1;\n    ", ";\n    background-position: bottom left;\n    ", ";\n    padding-bottom: ", ";\n  "], ["\n    flex-grow: 1;\n    ", ";\n    background-position: bottom left;\n    ", ";\n    padding-bottom: ", ";\n  "])), theme_1.theme.DOT_BG('h', 'line-mid'), theme_1.theme.RESPONSIVE_FONT_SIZE('small'), theme_1.theme.UNIT(4))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-family: ", ";\n    padding: 0;\n    display: flex;\n    font-size: ", ";\n    flex-direction: column;\n  "], ["\n    font-family: ", ";\n    padding: 0;\n    display: flex;\n    font-size: ", ";\n    flex-direction: column;\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(15)),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-end;\n  "], ["\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-end;\n  "])))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n    line-height: 1.25em;\n    font-size: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n    line-height: 1.25em;\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(18))
});
var DefinitionTableStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: 100%;\n    margin-top: ", ";\n    font-size: ", ";\n  "], ["\n    width: 100%;\n    margin-top: ", ";\n    font-size: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.FONT_SIZE(15))
});
var TitleAndTypeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin: ", " 0;\n    order: 3;\n  "], ["\n    margin: ", " 0;\n    order: 3;\n  "])), theme_1.theme.UNIT(2)),
  tablet: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin: 0;\n    order: 1;\n  "], ["\n    margin: 0;\n    order: 1;\n  "])))
});
var TypeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var TypeLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TypeValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: inline-block;\n    padding-left: ", ";\n    color: ", ";\n    font-weight: 400;\n    text-transform: none;\n  "], ["\n    display: inline-block;\n    padding-left: ", ";\n    color: ", ";\n    font-weight: 400;\n    text-transform: none;\n  "])), theme_1.theme.UNIT(1), theme_1.theme.COLOR('dark'))
});
var StatusAndDueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    order: 1;\n    justify-content: space-between;\n    margin-bottom: ", ";\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    order: 1;\n    justify-content: space-between;\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(2)),
  tablet: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    order: 3;\n    justify-content: flex-end;\n    margin-bottom: 0;\n  "], ["\n    order: 3;\n    justify-content: flex-end;\n    margin-bottom: 0;\n  "])))
});
var StatusStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    margin: 0;\n    font-size: ", ";\n    margin: ", " 0;\n  "], ["\n    margin: 0;\n    font-size: ", ";\n    margin: ", " 0;\n  "])), theme_1.theme.FONT_SIZE(15), theme_1.theme.UNIT(2)),
  tablet: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    margin: 0;\n  "], ["\n    margin: 0;\n  "])))
});
var DueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    text-transform: uppercase;\n    font-weight: 400;\n    flex-shrink: 0;\n    height: ", ";\n    display: flex;\n    align-items: center;\n    b {\n      padding-left: ", ";\n      text-transform: none;\n    }\n  "], ["\n    text-transform: uppercase;\n    font-weight: 400;\n    flex-shrink: 0;\n    height: ", ";\n    display: flex;\n    align-items: center;\n    b {\n      padding-left: ", ";\n      text-transform: none;\n    }\n  "])), theme_1.theme.UNIT(11), theme_1.theme.UNIT(1)),
  tablet: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(2)),
  desktop: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    text-decoration: none;\n    display: inline-block;\n    color: ", ";\n  "], ["\n    text-decoration: none;\n    display: inline-block;\n    color: ", ";\n  "])), theme_1.theme.COLOR('primary'))
});
var CreateIconButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var FooterStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    display: flex;\n    padding: ", " 0;\n  "], ["\n    display: flex;\n    padding: ", " 0;\n  "])), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    justify-content: flex-end;\n  "], ["\n    justify-content: flex-end;\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    padding-left: 0;\n    padding-bottom: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    padding-left: 0;\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "])))
});
var DetailsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    box-sizing: border-box;\n    width: 100%;\n    padding: 0 ", ";\n  "], ["\n    box-sizing: border-box;\n    width: 100%;\n    padding: 0 ", ";\n  "])), theme_1.theme.UNIT(2))
});
var ThumbnailStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    border: 1px solid ", ";\n    padding: ", ";\n    background: #FFF;\n    display: block;\n  "], ["\n    border: 1px solid ", ";\n    padding: ", ";\n    background: #FFF;\n    display: block;\n  "])), theme_1.theme.COLOR('line-mid'), theme_1.theme.UNIT(1))
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    max-width: 100%;\n    display: block;\n  "], ["\n    max-width: 100%;\n    display: block;\n  "])))
});
var FeatureLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    display: block;\n    flex-shrink: 0;\n    margin-top: 4px;\n    width: 100%;\n    margin-bottom: ", ";\n  "], ["\n    display: block;\n    flex-shrink: 0;\n    margin-top: 4px;\n    width: 100%;\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n    max-width: 400px;\n    max-height: none;\n    width: 25%;\n    margin-right: ", ";\n    margin-bottom: 0;\n    \n  "], ["\n    max-width: 400px;\n    max-height: none;\n    width: 25%;\n    margin-right: ", ";\n    margin-bottom: 0;\n    \n  "])), theme_1.theme.UNIT(6))
});
var NumberStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n    margin-right: ", ";\n    flex-shrink: 0;\n  "], ["\n    margin-right: ", ";\n    flex-shrink: 0;\n  "])), theme_1.theme.UNIT(3))
});
var TasksContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n    position: relative;\n    background-position: bottom left;\n    margin-bottom: ", ";\n  "], ["\n    position: relative;\n    background-position: bottom left;\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var TasksStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n    padding: 0;\n    position: relative;\n    line-height: 1.25em;\n    margin-top: 0;\n    top: -", ";\n    padding-top: ", ";\n    margin-left: ", ";\n    margin-bottom: -", ";\n    ", ";\n    background-position: 9px 0px;\n\n    ", "\n\n  "], ["\n    padding: 0;\n    position: relative;\n    line-height: 1.25em;\n    margin-top: 0;\n    top: -", ";\n    padding-top: ", ";\n    margin-left: ", ";\n    margin-bottom: -", ";\n    ", ";\n    background-position: 9px 0px;\n\n    ", "\n\n  "])), theme_1.theme.UNIT(5), theme_1.theme.UNIT(9), theme_1.theme.UNIT(3, -1), theme_1.theme.UNIT(4.5), theme_1.theme.DOT_BG('v', 'line-mid', 2, 4), function (props) {
    return props.showDetails && (0, styled_components_1.css)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n      top: 0px;\n      padding-top: ", ";\n      margin-top: ", ";\n      margin-bottom: ", ";\n      &:first-child {\n        margin-top: 0;\n        padding-top: ", ";\n\n      }\n    "], ["\n      top: 0px;\n      padding-top: ", ";\n      margin-top: ", ";\n      margin-bottom: ", ";\n      &:first-child {\n        margin-top: 0;\n        padding-top: ", ";\n\n      }\n    "])), theme_1.theme.UNIT(0), theme_1.theme.UNIT(6), theme_1.theme.UNIT(6), theme_1.theme.UNIT(6));
  })
});
var TasksBorderMaskStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n    position: absolute;\n    height: 2px;\n    width: ", ";\n    top: -2px;\n    z-index: 10;\n    left: 0px;\n\n    ", "\n  "], ["\n    position: absolute;\n    height: 2px;\n    width: ", ";\n    top: -2px;\n    z-index: 10;\n    left: 0px;\n\n    ", "\n  "])), theme_1.theme.UNIT(5.5), function (props) {
    return (0, styled_components_1.css)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), theme_1.theme.COLOR(props._color));
  })
});
var TaskItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n    margin-bottom: ", ";\n\n    ", "\n\n    &:last-child {\n      margin-bottom: 0;\n      padding-bottom: 0;\n    }\n  "], ["\n    margin-bottom: ", ";\n\n    ", "\n\n    &:last-child {\n      margin-bottom: 0;\n      padding-bottom: 0;\n    }\n  "])), theme_1.theme.UNIT(4), function (props) {
    return props.showDetails && (0, styled_components_1.css)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n      padding-bottom: 10px;\n    "], ["\n      padding-bottom: 10px;\n    "])));
  })
});
var TitleLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var CellHeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components ------------>
var My = {
  Card: (0, styled_components_1.default)(card_1.Card)(templateObject_40 || (templateObject_40 = __makeTemplateObject([""], [""]))),
  Header: styled_components_1.default.div(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  DefinitionTable: (0, styled_components_1.default)(definition_table_1.DefinitionTable)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), DefinitionTableStyles),
  Number: (0, styled_components_1.default)(item_number_1.ItemNumber)(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), NumberStyles),
  Content: (0, styled_components_1.default)(content_1.Content)(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Title: styled_components_1.default.span(templateObject_45 || (templateObject_45 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  TitleLink: (0, styled_components_1.default)(entity_link_1.EntityLink)(templateObject_46 || (templateObject_46 = __makeTemplateObject(["", ""], ["", ""])), TitleLinkStyles),
  Body: styled_components_1.default.div(templateObject_47 || (templateObject_47 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Details: styled_components_1.default.div(templateObject_48 || (templateObject_48 = __makeTemplateObject(["", ""], ["", ""])), DetailsStyles),
  FeatureLink: styled_components_1.default.a(templateObject_49 || (templateObject_49 = __makeTemplateObject(["", ""], ["", ""])), FeatureLinkStyles),
  Thumbnail: styled_components_1.default.div(templateObject_50 || (templateObject_50 = __makeTemplateObject(["", ""], ["", ""])), ThumbnailStyles),
  Image: styled_components_1.default.img(templateObject_51 || (templateObject_51 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  TitleAndType: styled_components_1.default.div(templateObject_52 || (templateObject_52 = __makeTemplateObject(["", ""], ["", ""])), TitleAndTypeStyles),
  CellHeader: (0, styled_components_1.default)(entity_cell_header_1.EntityCellHeader)(templateObject_53 || (templateObject_53 = __makeTemplateObject(["", ""], ["", ""])), CellHeaderStyles),
  Type: (0, styled_components_1.default)(cell_label_1.CellLabel)(templateObject_54 || (templateObject_54 = __makeTemplateObject(["", ""], ["", ""])), TypeStyles),
  TypeLabel: styled_components_1.default.span(templateObject_55 || (templateObject_55 = __makeTemplateObject(["", ""], ["", ""])), TypeLabelStyles),
  TypeValue: styled_components_1.default.span(templateObject_56 || (templateObject_56 = __makeTemplateObject(["", ""], ["", ""])), TypeValueStyles),
  StatusAndDue: styled_components_1.default.div(templateObject_57 || (templateObject_57 = __makeTemplateObject(["", ""], ["", ""])), StatusAndDueStyles),
  Status: (0, styled_components_1.default)(project_status_label_1.ProjectStatusLabel)(templateObject_58 || (templateObject_58 = __makeTemplateObject(["", ""], ["", ""])), StatusStyles),
  Due: styled_components_1.default.time(templateObject_59 || (templateObject_59 = __makeTemplateObject(["", ""], ["", ""])), DueStyles),
  Link: (0, styled_components_1.default)(link_1.Link)(templateObject_60 || (templateObject_60 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  TasksContainer: styled_components_1.default.div(templateObject_61 || (templateObject_61 = __makeTemplateObject(["", ""], ["", ""])), TasksContainerStyles),
  TasksBorderMask: styled_components_1.default.span(templateObject_62 || (templateObject_62 = __makeTemplateObject(["", ""], ["", ""])), TasksBorderMaskStyles),
  Tasks: styled_components_1.default.ul(templateObject_63 || (templateObject_63 = __makeTemplateObject(["", ""], ["", ""])), TasksStyles),
  TaskItem: (0, styled_components_1.default)(task_item_1.TaskItem)(templateObject_64 || (templateObject_64 = __makeTemplateObject(["", ""], ["", ""])), TaskItemStyles),
  CreateIconButton: (0, styled_components_1.default)(icon_button_1.CreateIconButton)(templateObject_65 || (templateObject_65 = __makeTemplateObject(["", ""], ["", ""])), CreateIconButtonStyles),
  Footer: styled_components_1.default.div(templateObject_66 || (templateObject_66 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles)
};
My.Card = (0, styled_components_1.default)(card_1.Card)(templateObject_67 || (templateObject_67 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), CardStyles);
var WorkstreamCard = function (props) {
  var className = props.className,
    entity = props.entity,
    border = props.border,
    statusLabel = props.statusLabel,
    backgroundColor = props.backgroundColor,
    number = props.number;
  var _a = entity.files,
    files = _a === void 0 ? [] : _a,
    _b = entity.tasks,
    tasks = _b === void 0 ? [] : _b,
    _c = entity.links,
    links = _c === void 0 ? [] : _c,
    _d = entity.description,
    description = _d === void 0 ? {
      html: '',
      text: ''
    } : _d;
  var content = description.html || description.text;
  var _e = (0, use_app_options_1.useAppOptions)(),
    thumbnailFileTypes = _e.thumbnailFileTypes,
    thumbnailLinkTypes = _e.thumbnailLinkTypes;
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var card = definition.card,
    label = definition.label;
  var _f = (0, use_entities_1.useEntities)(),
    Team = _f.Team,
    Document = _f.Document;
  var t = (0, use_lang_1.useLang)();
  var icons = (0, use_icons_1.useIcons)();
  var definitions = (0, lodash_1.filter)(__spreadArray(__spreadArray(__spreadArray([], __read((entity.documents || []).map(function (document) {
    return {
      id: document.id,
      name: document.type && document.type.name || t('Document'),
      value: React.createElement(My.Link, {
        inverted: true,
        to: Document && Document.to(document.slug)
      }, document.name),
      icon: icons.DocumentCircle
    };
  })), false), __read((0, lodash_1.filter)(entity.links || [], function (link) {
    return !!link.url;
  }).map(function (link) {
    return {
      id: link.id,
      name: link.type && link.type.name || t('Link'),
      value: React.createElement(My.Link, {
        inverted: true,
        to: link.url
      }, link.name),
      icon: icons.Entities.Link
    };
  })), false), __read((0, lodash_1.filter)(entity.files || [], function (file) {
    return file.file && !!file.file.url;
  }).map(function (file) {
    return {
      id: file.id,
      name: file.type && file.type.name || t('File'),
      value: React.createElement(My.Link, {
        inverted: true,
        to: file.file.url
      }, file.name),
      icon: icons.Entities.FileAsset
    };
  })), false), function (item) {
    return !!(item && item.value);
  });
  var to = definition.to(entity.slug);
  var featureLink = links.find(function (link) {
    return (link.types || []).find(function (linkType) {
      return (0, lodash_1.includes)(thumbnailLinkTypes, linkType.name);
    });
  });
  var featureFile = files.find(function (file) {
    return (file.types || []).find(function (fileType) {
      return (0, lodash_1.includes)(thumbnailFileTypes, fileType.name);
    });
  });
  var hasTasks = !!tasks.length;
  var hasFeatureLink = featureLink && featureLink.image && !!featureLink.image.url && !!featureLink.url;
  var hasFeatureFile = !hasFeatureLink && featureFile && featureFile.file && featureFile.file.url && !!featureFile.thumbnail && !!featureFile.thumbnail.url;
  var hasStatus = !!entity.status;
  var hasDue = !!entity.due;
  var hasStatusAndDue = hasStatus || hasDue;
  return React.createElement(My.Card, {
    _backgroundColor: backgroundColor,
    border: border,
    space: 0,
    className: className,
    title: React.createElement(My.Header, {
      hasBorder: hasTasks
    }, React.createElement(My.TitleAndType, null, React.createElement(My.CellHeader, {
      entity: entity,
      badge: entity.status && entity.status.name
    }, React.createElement(My.TypeLabel, null, t(label)), entity.type && React.createElement(My.TypeValue, null, "(", entity.type.name, ")")), React.createElement(My.Title, null, hasTasks, number && React.createElement(My.Number, {
      value: number
    }), entity.name)), hasStatusAndDue && React.createElement(My.StatusAndDue, null, hasDue && React.createElement(My.Due, {
      datetime: entity.due
    }, t('Due'), ': ', React.createElement("b", null, (0, format_date_string_1.formatDateString)(entity.due, 'D MMM YY')))))
  }, hasTasks && React.createElement(My.TasksContainer, null, React.createElement(My.Tasks, {
    showDetails: true
  }, tasks.map(function (task) {
    return React.createElement(My.TaskItem, {
      showDetails: true,
      key: task.id,
      entity: task
    });
  }))), React.createElement(My.Body, null, hasFeatureLink && React.createElement(My.FeatureLink, {
    target: "_blank",
    href: featureLink.url
  }, React.createElement(My.Thumbnail, null, React.createElement(My.Image, {
    src: featureLink.image.url
  }))), hasFeatureFile && React.createElement(My.FeatureLink, {
    target: "_blank",
    href: featureFile.file && featureFile.file.url
  }, React.createElement(My.Thumbnail, null, React.createElement(My.Image, {
    src: featureFile.thumbnail.url
  }))), React.createElement(My.Details, null, content && React.createElement(My.Content, {
    html: content
  }), React.createElement(My.DefinitionTable, {
    columns: 1,
    dividers: false,
    justify: "flex-start",
    items: definitions
  }))));
};
exports.WorkstreamCard = WorkstreamCard;
exports.WorkstreamCard.defaultProps = exports.WorkstreamCardDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60, templateObject_61, templateObject_62, templateObject_63, templateObject_64, templateObject_65, templateObject_66, templateObject_67;